import React, { useEffect, useState } from "react";
import axios from "axios";
import "./styles.css";

//const API = "http://127.0.0.1:8000";
const API = process.env.REACT_APP_API_URL;

function actionBtnStyle(bg, color) {
  return {
    background: bg, color,
    border: `1px solid ${color}22`,
    borderRadius: "6px", padding: "4px 8px",
    cursor: "pointer", fontSize: "13px",
    lineHeight: 1, whiteSpace: "nowrap", flexShrink: 0,
  };
}

function ProjectDetails() {
  const [data, setData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [saving, setSaving] = useState(null);
  const [editedRows, setEditedRows] = useState({});
  const [viewRow, setViewRow] = useState(null);
  const [viewRowIdx, setViewRowIdx] = useState(null);
  const [copied, setCopied] = useState(null);
  const [editCell, setEditCell] = useState(null);
  const [editValue, setEditValue] = useState("");

  const token = localStorage.getItem("admin_token");

  const fetchData = async () => {
    setTableLoading(true);
    try {
      const res = await axios.get(`${API}/projects`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const allHeaders = data[0] ? Object.keys(data[0]) : [];
  const headers = allHeaders.filter(h => h !== "Unique Key");

  const copyToClipboard = async (text, id) => {
    await navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 1500);
  };

  const startEdit = (colKey, currentValue) => { setEditCell(colKey); setEditValue(currentValue ?? ""); };
  const cancelEdit = () => { setEditCell(null); setEditValue(""); };

  const confirmEdit = (colKey) => {
    const updated = [...data];
    updated[viewRowIdx] = { ...updated[viewRowIdx], [colKey]: editValue };
    setData(updated);
    setViewRow(updated[viewRowIdx]);
    setEditedRows((prev) => ({ ...prev, [viewRowIdx]: { ...prev[viewRowIdx], [colKey]: editValue } }));
    setEditCell(null);
    setEditValue("");
  };

  const saveRow = async (rowIdx) => {
    if (!editedRows[rowIdx]) return;
    setSaving(rowIdx);
    try {
      await axios.put(
        `${API}/projects/update`,
        { row_index: rowIdx, updatedData: data[rowIdx] },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditedRows((prev) => { const c = { ...prev }; delete c[rowIdx]; return c; });
      alert("✅ Updated in Google Sheet!");
    } catch (err) {
      alert("❌ Failed: " + (err.response?.data?.detail || err.message));
    } finally {
      setSaving(null);
    }
  };

  const openView = (row, idx) => { setViewRow(row); setViewRowIdx(idx); setEditCell(null); setEditValue(""); };
  const closeView = () => { setViewRow(null); setViewRowIdx(null); setEditCell(null); setEditValue(""); };

  return (
    <div className="container">
      <h1>📄 Project Details</h1>

      {viewRow && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: "12px", padding: "32px", width: "640px", maxWidth: "90%", maxHeight: "85vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h2 style={{ margin: 0, color: "#1a3c6e" }}>📁 Project Details</h2>
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                {editedRows[viewRowIdx] && (
                  <button onClick={() => saveRow(viewRowIdx)} disabled={saving === viewRowIdx}
                    style={{ background: "#1a3c6e", color: "#fff", border: "none", borderRadius: "8px", padding: "6px 14px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>
                    {saving === viewRowIdx ? "⏳ Saving..." : "💾 Save Changes"}
                  </button>
                )}
                <button onClick={closeView} style={{ background: "none", border: "none", fontSize: "22px", cursor: "pointer", color: "#666" }}>✖</button>
              </div>
            </div>

            {headers.map((key) => {
              const val = viewRow[key];
              const isEditing = editCell === key;
              return (
                <div key={key} style={{ marginBottom: "10px", borderBottom: "1px solid #eee", paddingBottom: "10px" }}>
                  <div style={{ fontSize: "12px", color: "#888", marginBottom: "6px" }}>{key}</div>
                  {isEditing ? (
                    <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                      <input style={{ flex: 1, padding: "6px 10px", fontSize: "14px", border: "1px solid #1a3c6e", borderRadius: "6px", outline: "none" }}
                        value={editValue} autoFocus
                        onChange={(e) => setEditValue(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter") confirmEdit(key); if (e.key === "Escape") cancelEdit(); }} />
                      <button onClick={() => confirmEdit(key)} style={actionBtnStyle("#e6f4ea", "#2e7d32")}>✔</button>
                      <button onClick={cancelEdit} style={actionBtnStyle("#fdecea", "#c62828")}>✖</button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{ flex: 1, fontSize: "14px", color: "#333" }}>{String(val ?? "—")}</span>
                      <button onClick={() => copyToClipboard(String(val ?? ""), key)} style={actionBtnStyle("#f0f4ff", "#1a3c6e")}>{copied === key ? "✔" : "📋"}</button>
                      <button onClick={() => startEdit(key, val)} style={actionBtnStyle("#f0f4ff", "#1a3c6e")}>✎</button>
                    </div>
                  )}
                </div>
              );
            })}

            <button onClick={closeView} style={{ marginTop: "20px", width: "100%", padding: "10px", background: "#1a3c6e", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px" }}>Close</button>
          </div>
        </div>
      )}

      <div className="table-wrapper">
        {tableLoading ? (
          <div className="table-loader"><span className="spinner dark"></span><div className="loading-text">Loading projects...</div></div>
        ) : (
          <table>
            <thead>
              <tr>
                {headers.map((h) => <th key={h}>{h}</th>)}
                <th style={{ whiteSpace: "nowrap", minWidth: "60px" }}>View</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => (
                <tr key={i} className={editedRows[i] ? "row-edited" : ""}>
                  {headers.map((key, j) => (
                    <td key={j}><span className="cell-text">{String(row[key] ?? "")}</span></td>
                  ))}
                  <td>
                    <button className="copy-btn" onClick={() => openView(row, i)} title="View / Edit details">
                      {editedRows[i] ? "💾" : "👁"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ProjectDetails;
